export const CommonConstants = {
  KEYS: {
    SELECTED_ORG: "selected_org",
    UMP_ORGCODE: "UMP",
    UMP_ID: 31
  }
};
